import { Server } from 'lucide-react';
import { psmGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function PMSDashboardPage() {
  return <LiveDashboardPage title="PMS" description="Platform Management System" icon={Server} getData={psmGet} />;
}
